import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';

import { Footer } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';
import EditTimesheetFooterButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/EditTimesheetFooterButton';
import CloseTimesheetFooterButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/CloseTimesheetFooterButton';
import MoreTimesheetFooterButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/TimesheetViewModalManagerFooter/MoreTimesheetFooterButton/MoreTimesheetFooterButton';
import ApproveTimesheetFooterButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/ApproveTimesheetFooterButton';

const hideEditButtonStatuses = [TimesheetStatus.pending, TimesheetStatus.approved];

type Props = {
  onClose: VoidFunction;
  onEdit: VoidFunction;
  onApprove: () => Promise<void>;
  onMarkPending: () => Promise<void>;
  timesheetStatus: TimesheetStatus;
};

const TimesheetViewModalManagerFooter = ({
  onClose,
  onEdit,
  onApprove,
  onMarkPending,
  timesheetStatus,
}: Props) => {
  const isMainEditButtonVisible = !hideEditButtonStatuses.includes(timesheetStatus);

  return (
    <Footer>
      <MoreTimesheetFooterButton
        onEdit={onEdit}
        onApprove={onApprove}
        onMarkPending={onMarkPending}
        timesheetStatus={timesheetStatus}
        shouldHideEdit={isMainEditButtonVisible}
      />
      <CloseTimesheetFooterButton onClose={onClose} />
      {isMainEditButtonVisible && <EditTimesheetFooterButton onEdit={onEdit} />}
      {timesheetStatus === TimesheetStatus.pending && (
        <ApproveTimesheetFooterButton onApprove={onApprove} />
      )}
    </Footer>
  );
};

export default TimesheetViewModalManagerFooter;
